import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './FAQPage.css';

export default function FAQPage() {
  const [activeCategory, setActiveCategory] = useState('travel');

  const faqData = {
    travel: [
      {
        question: "What is GRADEDWASH.COM's role in travel bookings?",
        answer: "GRADEDWASH.COM acts exclusively as a travel agent. We connect you with trusted travel companies and tour operators who organize and provide the actual holidays, tours, accommodation, transport, and activities. We do not organize, operate, or provide any travel services ourselves."
      },
      {
        question: "Does GRADEDWASH.COM organize local meetings or trips?",
        answer: "No, we do not organize or operate any local meets, hotels, train journeys, or tours. We only facilitate links to the best travel holiday options available through the travel companies we collaborate with."
      },
      {
        question: "Can I book any travel service directly through GRADEDWASH.COM?",
        answer: "We provide information and direct you to travel companies that offer a wide variety of holidays and travel-related services. Any bookings are made with those travel operators or service providers, not through GRADEDWASH.COM directly."
      },
      {
        question: "What kind of travel information does GRADEDWASH.COM provide?",
        answer: "We offer informational resources including travel warnings, advice on unusual or off-the-beaten-path destinations, and details on the diverse types of holiday options available, helping you make informed travel decisions."
      },
      {
        question: "Does GRADEDWASH.COM offer group travel options?",
        answer: "We encourage group travel as a great way to explore, but all group trips are organized by the partner travel companies. We provide connections and information but do not manage or operate group travel ourselves."
      },
      {
        question: "Who do I contact for support or changes after booking?",
        answer: "Since bookings are made with third-party travel organizers, you will need to contact them directly for any changes, cancellations, or support. GRADEDWASH.COM can assist in directing you to the right contact but does not manage bookings or customer service for individual holidays."
      },
      {
        question: "How do I know the travel holidays offered are reliable?",
        answer: "We work with reputable and vetted travel companies to ensure quality and safety. However, the responsibility for organizing and delivering the holiday lies with those providers."
      },
      {
        question: "Can I buy gift vouchers or book corporate/group travel through GRADEDWASH.COM?",
        answer: "Gift vouchers and group or corporate travel can be arranged through our partner travel companies. We can provide information and direct you to these services but do not issue vouchers or handle bookings ourselves."
      }
    ],
    localMeets: [
      {
        question: "What are Local Meets on GRADEDWASH.COM?",
        answer: "Local Meets are community-organized events where members can meet up in person. These are created and managed by our community members, not by GRADEDWASH.COM. We provide the platform for members to discover and join these meets."
      },
      {
        question: "Who organizes Local Meets?",
        answer: "Local Meets are organized entirely by community members. GRADEDWASH.COM provides the platform and tools for members to create and join meets, but we do not organize, host, or manage any of these events ourselves."
      },
      {
        question: "Is GRADEDWASH.COM responsible for what happens at Local Meets?",
        answer: "No. GRADEDWASH.COM is not responsible for any events, activities, or behaviors that occur at Local Meets. All meets are organized by community members, and participants attend at their own risk. We strongly encourage all members to follow safety guidelines and report any concerning behavior."
      },
      {
        question: "How do I join a Local Meet?",
        answer: "Browse the Local Meets page to find events in your area. Click on any meet to see details and use the 'Join Meet' button to register your interest. The meet organizer will then contact you with further details."
      },
      {
        question: "Can I create my own Local Meet?",
        answer: "Yes! Any verified member can create a Local Meet. Simply go to the Local Meets page and click 'Create a Local Meet'. Fill in the details including location, date, time, and description of the activity."
      },
      {
        question: "What safety measures are in place for Local Meets?",
        answer: "While GRADEDWASH.COM provides safety guidelines and reporting tools, we cannot guarantee the safety of any meet. We recommend meeting in public places, bringing a friend, and following our safety guidelines. Always trust your instincts and report any concerning behavior."
      },
      {
        question: "What if something goes wrong at a Local Meet?",
        answer: "If you experience any issues at a Local Meet, please report it immediately through our safety reporting system. While GRADEDWASH.COM cannot be held responsible for events organized by community members, we take all reports seriously and will investigate any violations of our community guidelines."
      },
      {
        question: "Are Local Meets free to join?",
        answer: "Most Local Meets are free to join, though some organizers may charge for specific activities or venues. Any costs will be clearly stated in the meet description. GRADEDWASH.COM does not charge for the use of our Local Meets platform."
      }
    ],
    general: [
      {
        question: "How does personality matching work?",
        answer: "Our advanced algorithm analyzes your responses to our comprehensive personality quiz, considering factors like travel style, communication preferences, and interests. We then match you with compatible travelers who share similar values and travel goals."
      },
      {
        question: "Is GRADEDWASH.COM safe to use?",
        answer: "Yes! We prioritize your safety with verified profiles, secure messaging, and comprehensive safety guidelines. All users must complete identity verification, and we have a dedicated safety team monitoring the platform."
      },
      {
        question: "How much does it cost to use GradedWash?",
        answer: "Basic features are free! You can create a profile, take the personality test, receive an evaluation that will be seen by others and browse potential matches plus access our travel warnings and info plus details of trending travel locations, including more off beat and unusual holidays or travel opportunities such as travel weekend trips organized by members. There is a friendly AI companion standing by willing to help you. Premium features like unlimited messaging, local meets, and travel groups require a subscription starting at £8.99/month including our friendly AI companion to chat to and to help you with any problems you have."
      },
      {
        question: "Can I cancel my subscription anytime?",
        answer: "Absolutely! You can cancel your subscription at any time through your account settings. You'll continue to have access to premium features until the end of your current billing period."
      },
      {
        question: "What if I have a bad experience with a match?",
        answer: "We take all reports seriously. If you have concerns about a user, please report them immediately through our safety reporting system. Our team will investigate and take appropriate action."
      },
      {
        question: "How can I contact GRADEDWASH.COM?",
        answer: "You can reach us via our website contact form, email, or phone during business hours for travel information and guidance on connecting with travel companies."
      }
    ]
  };

  const categories = [
    { id: 'travel', name: 'Travel Services', icon: '✈️' },
    { id: 'localMeets', name: 'Local Meets', icon: '🤝' },
    { id: 'general', name: 'General', icon: '❓' }
  ];

  return (
    <div className="faq-page">
      <div className="container">
        {/* Header */}
        <div className="faq-header">
          <h1>Frequently Asked Questions</h1>
          <p>Find answers to common questions about GRADEDWASH.COM services and features</p>
        </div>

        {/* Category Navigation */}
        <div className="category-nav">
          {categories.map(category => (
            <button
              key={category.id}
              className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
              onClick={() => setActiveCategory(category.id)}
            >
              <span className="category-icon">{category.icon}</span>
              <span className="category-name">{category.name}</span>
            </button>
          ))}
        </div>

        {/* FAQ Content */}
        <div className="faq-content">
          <div className="faq-grid">
            {faqData[activeCategory].map((faq, index) => (
              <div key={index} className="faq-item">
                <h3 className="faq-question">{faq.question}</h3>
                <p className="faq-answer">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Important Notice */}
        <div className="important-notice">
          <h3>⚠️ Important Notice</h3>
          <p>
            <strong>Travel Services:</strong> GRADEDWASH.COM acts solely as a travel agent connecting you with third-party travel providers. We do not organize, operate, or provide any travel services ourselves.
          </p>
          <p>
            <strong>Local Meets:</strong> All Local Meets are organized by community members, not by GRADEDWASH.COM. We provide the platform but are not responsible for any events, activities, or behaviors that occur at these meets. Participants attend at their own risk.
          </p>
        </div>

        {/* Contact Section */}
        <div className="contact-section">
          <h3>Still have questions?</h3>
          <p>Can't find what you're looking for? Get in touch with our support team.</p>
          <div className="contact-buttons">
            <Link to="/contact" className="btn btn--primary">
              Contact Support
            </Link>
            <Link to="/terms-of-service" className="btn btn--secondary">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
} 